<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span class="bid_item_title">备案告知</span>
      <el-button @click="moreCast" class="bid_more" type="text">
        更多
        <i class="el-icon-arrow-right el-icon--right"></i>
      </el-button>
    </div>
    <div
      v-for="(nItem,index) in bidCasteArr"
      :key="index"
      class="bid_note_item"
      @click="seeBidCast(nItem.bidsId)"
    >
      <el-row :gutter="20">
        <el-col :span="19">
          <div class="bid_common_item">
            <span>{{nItem.bidsName}}</span>
          </div>
        </el-col>
        <el-col :span="5">
          <div>{{nItem.promTime}}</div>
        </el-col>
      </el-row>
    </div>
    <div v-show="isCastPage" class="bid_pagination">
      <el-pagination
        @size-change="sizeChangeCtl"
        @current-change="pageTurn"
        :current-page="cPageSize"
        :page-sizes="[10, 20, 30]"
        :page-size="cPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="cPageNoSum"
      ></el-pagination>
    </div>
  </el-card>
</template>
<script>
import { bidList } from '@/api/frontApi/bidding';
export default {
  data() {
    return {
      isCastPage: false,
      bidCasteArr: [],
      cPageNoSum: 1,
      cPageSize: 10,
      cPageNo: 1
    };
  },
  created() {
    this.initBidCastData(1, 5, false);
  },
  methods: {
    initBidCastData(pageNo, pageSize, flag) {
      if (flag) this.isCastPage = flag;
      else this.isCastPage = false;
      bidList(pageNo, pageSize, 2).then(res => {
        this.cPageNoSum = parseInt(res.data.pageTotal);
        this.bidCasteArr = [];
        this.bidCasteArr = res.data.list;
      });
    },
    seeBidCast(bidsId) {
      if (bidsId) {
        this.$router.push({
          name: 'biddingInfo',
          params: {
            bidId: bidsId,
            itemNmae: '备案告知'
          }
        });
      }
    },
    moreCast() {
      this.$emit('sendBack', 2);
      this.initBidCastData(this.cPageNo, this.cPageSize, true);
    },
    sizeChangeCtl(val) {
      this.cPageSize = val;
      this.initBidCastData(this.cPageNo, this.cPageSize, true);
    },
    pageTurn(val) {
      this.cPageNo = val;
      this.initBidCastData(this.cPageNo, this.cPageSize, true);
    }
  }
};
</script>
<style lang="stylus" scoped>
.bid_note_item {
  height: 28px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/bidding/bidForcast.vue